"use client";

import { useSetRouteContext } from "@faire/web/common/routes/useRouteContext";

export interface RouteContextProps {
  productArea: string | undefined;
  pod: string | undefined;
  pillar: string | undefined;
  templatedPath: string | undefined;
}

/**
 * This component is used to set the Datadog route context for the current page.
 */
export const RouteContext: React.FC<
  RouteContextProps & { children: React.ReactNode }
> = ({ productArea, pod, pillar, templatedPath, children }) => {
  useSetRouteContext(productArea, pod, pillar, templatedPath);
  return children;
};
